import TransactionButton from '@/components/ui/transaction-button'
import { getCurrentTime } from '@/utils'
import { useLingui } from '@lingui/react/macro'
import dtfIndexGovernanceAbi from 'abis/dtf-index-governance'
import useContractWrite from 'hooks/useContractWrite'
import useWatchTransaction from 'hooks/useWatchTransaction'
import { atom, useAtomValue } from 'jotai'
import { useEffect, useState } from 'react'
import { proposalDetailAtom, proposalTxArgsAtom } from '../atom'
import { proposalRefreshFnAtom } from '../updater'

const canExecuteAtom = atom((get) => {
  const timestamp = getCurrentTime()
  const proposal = get(proposalDetailAtom)

  return proposal?.executionETA && proposal.executionETA <= timestamp
})

const ProposalExecute = () => {
  const { t } = useLingui()
  const proposal = useAtomValue(proposalDetailAtom)
  const canExecute = useAtomValue(canExecuteAtom)
  const deadline = proposal?.votingState.deadline
  const governor = proposal?.governor
  const txArgs = useAtomValue(proposalTxArgsAtom)
  const refreshFn = useAtomValue(proposalRefreshFnAtom)
  const [isProcessing, setIsProcessing] = useState(false)

  const { write, isLoading, hash, isReady, validationError } = useContractWrite(
    {
      abi: dtfIndexGovernanceAbi,
      address: governor && canExecute ? governor : undefined,
      functionName: 'execute',
      value: 0n,
      args: txArgs,
    }
  )

  const { isMining, status } = useWatchTransaction({
    hash,
    label: t`Execute proposal`,
  })

  useEffect(() => {
    if (status === 'success') {
      setIsProcessing(true)
      const timer = setTimeout(() => {
        refreshFn?.()
        setIsProcessing(false)
      }, 10000)

      return () => clearTimeout(timer)
    }
  }, [status])

  if (!deadline || deadline > 0) return null

  return (
    <TransactionButton
      size="sm"
      loading={isProcessing || isMining || isLoading}
      mining={isMining}
      disabled={!isReady || !canExecute || status === 'success'}
      onClick={write}
      text={isProcessing ? t`Processing...` : t`Execute proposal`}
      className="h-[44px]"
      error={validationError}
      errorWithName={false}
    />
  )
}

export default ProposalExecute
